import React from 'react'
import {
  Lock,
  SignOut,
  User
} from '@phosphor-icons/react'

const TowerProfileMenuPanel = ({
  displayName,
  email,
  workspaceTag,
  initials,
  onMyProfile,
  onChangePassword,
  onSignOut
}) => (
  <div className="tower-profile-panel">
    <div className="profile-menu-head">
      <div className="detail-user">
        <span className="avatar">{initials}</span>
        <div>
          <h3 className="top-bar-tower-menu__profile-name">{displayName}</h3>
          {email ? (
            <p className="top-bar-tower-menu__profile-email">{email}</p>
          ) : null}
        </div>
      </div>
      {workspaceTag ? (
        <span className="workspace-tag top-bar-tower-menu__profile-business">{workspaceTag}</span>
      ) : null}
    </div>

    <div className="menu-list">
      <button type="button" className="menu-item top-bar-tower-menu__option" onClick={onMyProfile}>
        <User className="icon" size={16} weight="regular" aria-hidden="true" />
        Mi perfil
      </button>
      <button
        type="button"
        className="menu-item top-bar-tower-menu__option"
        onClick={onChangePassword}
      >
        <Lock className="icon" size={16} weight="regular" aria-hidden="true" />
        Cambiar contraseña
      </button>
      <div className="menu-separator" aria-hidden="true" />
      <button
        type="button"
        className="menu-item danger top-bar-tower-menu__logout"
        onClick={onSignOut}
      >
        <SignOut className="icon" size={16} weight="regular" aria-hidden="true" />
        Cerrar sesión
      </button>
    </div>
  </div>
)

export default React.memo(TowerProfileMenuPanel)
